module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAABX0lEQVRIS63WT04CMRQG8O89xCt4BlgYjyAcwsBsjAtWeB0SAyuIGSYeAjwCcSFX0CuIeTXzR6WdTqeFznoyv3l9fV9Li1XWUwoz6sp4kiSfiPQs0vRKHTopkXqk+SrbQuEWCu90KcMYUAF88QaEPgivVIq8BdCLAWkAsD8IDylfnViQDZg+3H0USAyoCci//YecA7mAGnIKZALUlYG5ebRKQpfOB7BWYoWAvfmHvoATqS3dERQCtCJWCDJSitfFoFkqtAWGtSfmi9ocAaralbUlbEokL6SoaJleK/CuAhRBbib3yZtP1HkhRg/KSgKyrhUxmyyMMQvWIVnnRJomOTTrGpG2qAiBmif+9zyo4jpPU+euc/SohoQOmk9F9RQ+qsAWdrYt2wbp58kJgE/W/Z+MZwBtUHnGRwBcEM2X2QbAwDfsfGJE61F+W3l6fumzyIwuZBTjOqRV9M2ZME9/ABI+noGN805JAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/Close@2x.png
// module id = YrGn
// module chunks = 70